var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9486_13902)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9998 15.6316V12C15.9998 10.3431 14.6566 9 12.9998 9H6.16162V5.52632C6.16162 4.13107 7.29269 3 8.68794 3H20.4774C21.8727 3 23.0037 4.13107 23.0037 5.52632V13.1053L23.0204 17.7868C23.0214 18.0629 22.7983 18.2876 22.5222 18.2886C22.389 18.289 22.2611 18.2363 22.1669 18.1421L19.6563 15.6316H15.9998Z",
    fill: "#8405DA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.98486 18V13C1.98486 11.8954 2.88029 11 3.98486 11H11.9849C13.0894 11 13.9849 11.8954 13.9849 13V18C13.9849 19.1046 13.0894 20 11.9849 20H4.10059L2.85674 21.1905C2.65725 21.3815 2.34074 21.3745 2.1498 21.175C2.06073 21.082 2.01102 20.9581 2.01102 20.8293V18.3243C1.99381 18.2187 1.98486 18.1104 1.98486 18ZM6.49981 14C6.22367 14 5.99981 14.2239 5.99981 14.5C5.99981 14.7761 6.22367 15 6.49981 15H11.4998C11.7759 15 11.9998 14.7761 11.9998 14.5C11.9998 14.2239 11.7759 14 11.4998 14H6.49981ZM9.49981 16C9.22367 16 8.99981 16.2239 8.99981 16.5C8.99981 16.7761 9.22367 17 9.49981 17H11.4998C11.7759 17 11.9998 16.7761 11.9998 16.5C11.9998 16.2239 11.7759 16 11.4998 16H9.49981Z",
    fill: "#8405DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9486_13902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.94fb327cf0e1a371cc0cf310f01bc741.svg";
export { ForwardRef as ReactComponent };